export const ADD_SUCCESS = 'Новая страна добавлена';
export const ADD_ERROR = 'Не удалось добавить страну';
